import { idGenerator, uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { Rect } from '../../../platform/geom/Rect';

const newId = idGenerator(uuid('nodash').slice(0, 8));

export interface Ping {
    readonly id: string;
    readonly color: string;
    // readonly region: Rect;
}

export class CanvasPing implements Ping {

    public static readonly defaultTtl = 6000;
    public static readonly cdt = 333;

    public readonly id = newId();

    constructor(public readonly color: string, public readonly region: Rect, public readonly ttl: number = 6000) {
    }
}

export class UIPing implements Ping {

    public static readonly ttl = 6000;
    public static readonly cdt = 333;

    public readonly id = newId();

    constructor(public readonly color: string, public uiElmtId: string) {
    }

    public get region(): Rect {
        const elmt = document.getElementById(this.uiElmtId);
        if (!elmt) return null;
        const { left, top, width, height } = elmt.getBoundingClientRect();


        return new Rect(left, top, width, height);
    }
}
